import { ComponentsManager } from '../core/smpl-components'

import ComponentBody from '../components/body'
import ComponentPageHero from '../components/page-hero'
import ComponentFaqAccordion from '../components/faq-accordion'
import ComponentMainNav from '../components/main-nav'
import ComponentActivitiesList from '../components/activities-list'
import ComponentStatisticsHighlight from '../components/statistics-highlight'
import ComponentScrollParallax from '../components/scroll-parallax'
import ComponentProgramCard from '../components/program-card'
import ComponentPageLogos from '../components/page-logos'
import ComponentArchiveList from '../components/archive-list'
import ComponentHomeScroller from '../components/home-scroller'
import ComponentStudioSlider from '../components/studio-slider'

// Component registry. Each entry maps a CSS selector to a component class,
// lazily loaded. Add new components here. See components/body.js for the
// reference implementation.
const componentRegistry = [
	{
		selector: 'body',
		name: 'body',
		loader: () => ComponentBody,
	},

	{
		selector: '.js-main-nav',
		name: 'main-nav',
		loader: () => ComponentMainNav,
	},

	{
		selector: 'body',
		name: 'scroll-parallax',
		loader: () => ComponentScrollParallax,
	},

	{
		selector: '.js-home-scroller',
		name: 'home-scroller',
		loader: () => ComponentHomeScroller,
	},
	{
		selector: '.js-studio-slider',
		name: 'studio-slider',
		loader: () => ComponentStudioSlider,
	},
]

export const initComponents = (ctx) => {
	ComponentsManager.setup({
		debug: true,
		components: componentRegistry,
		eventBus: ctx.eventBus,
	})

	ctx.componentsManager = ComponentsManager

	return ComponentsManager
}
